import { Heliora } from '../heliora/Heliora'
import { useUserContext } from '../user/UserContext'
import './Header.css'
const Header = () => {
  const {userData} = useUserContext()
  return (
    <div className='header-image'>
      {userData?.roles?.includes('admin') && <>
        <span title='Heliora' style={{float: 'left', left: '50px', position: 'sticky', top: 50}}>
        <Heliora />
        </span>
        <span title='Solthorn' style={{float: 'right', right: '50px', position: 'sticky', top: 50, filter: 'hue-rotate(180deg) saturate(200%)'}}>
          <Heliora isSolthorn={true} direction={-1} />
        </span>
      </>
      }
      <a href='/'>
        <img src='Sunnydaze-NHS.png'/>
      </a>
      <br/>
      <span className='header-text'>🔮 CRYSTAL BALL 🔮</span><br/>
      
    </div>
  )
}

export default Header